import { FC, ReactNode } from 'react';
import clsx from 'clsx';

import { Link as UILink } from '@getstream/ui-library/build';

export type Props = {
  className?: string;
  children: ReactNode | undefined;
  href: string;
  blue?: boolean;
  onClick?: () => void;
};

export const Link: FC<Props> = ({
  href,
  children,
  className,
  blue,
  ...props
}) => (
  <UILink
    to={href}
    className={clsx(className, {
      ['text-blue']: blue,
    })}
    {...props}
  >
    {children}
  </UILink>
);
